module.exports = __webpack_public_path__ + "assets/img/Future_BihouixThumb.a5b323fa-ps.jpg";